module.exports = __webpack_public_path__ + "img/6520.9d3a961f.jpg";